/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from "react"
import DeviceTable from "./Table"
import Limit from "../../../components/Limit"
import Pagination from "../../../components/Pagination"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import Emptyscreen from "../../../components/EmptyScreen"
import CustomOverLay from "../../../components/CustomOverLay"
import { useGetProviderAssociatedToPatientListQuery } from "../../../features/patientSlice"
import { useLocation, useSearchParams } from "react-router-dom"
import GlobalContext from "../../../components/Context/GloablContext"
import Emptyscreenwithouttitle from "../../../components/Emptyscreenwithouttitle"
import HelpGuideModal from "../../../components/HelpGuideModal"
import { useGetHelpGuideAdminQuery } from '../../../features/patientSlice'
import { dataService } from "../../../services/data.services"
import { BeatLoader } from "react-spinners"

export default function DeviceList({ patientId, patientTabName, setIsStateLoading }) {
    const { isSideBar } = useContext(GlobalContext)
    const location = useLocation()
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const [searchParams, setSearchParams] = useSearchParams('')

    // Check if other search parameters exist and append them to the query string


    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params[key] = value
        setSearchParams({ ...params })
    }

    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType = localStorage?.getItem('user_type') !== null ? localStorage.getItem('user_type') : sessionStorage.getItem('user_type')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-dashboard-provider-list');
        } else {
            setQueryParamsadmin('type=corporate-dashboard-provider-list');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    useEffect(() => {

        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            let params = {
                'limit': location.state.limit,
                'page_number': location.state.page_number,
            };
            setSearchParams({ ...params });
        } else {
            if (!searchParams?.get('limit')) {
                handleSearchParams('limit', '15');
            }
            if (!searchParams?.get('page_number')) {
                handleSearchParams('page_number', '1');
            }
        }
    }, [location, searchParams]);


    useEffect(() => {
        fetchData('initial');

    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isLoading]);

    const fetchData = async (isInitial) => {
        if (!hasMore) return;
        setIsLoading(true);
        setIsStateLoading(true)
        try {
            const res = await dataService.GetAPI(`patients/list-linked-devices/${patientId}?page_number=${page}&limit=15`)
            if (res.data.status === 200) {
                if (res?.data?.data?.data?.length === 0) {
                    setIsLoading(false)
                    setIsStateLoading(false)
                    setHasMore(false); // No more data available
                }
                setItems(prevItems => [...prevItems, ...res?.data?.data?.data])
                setPage(prevPage => prevPage + 1);
                setIsLoading(false);
                setIsStateLoading(false)

            }
        } catch (error) {
            setIsLoading(false);
            setIsStateLoading(false)

        }

    };

    const handleScroll = () => {
        if (((document.getElementById('device_scrollarea').scrollTop + document.getElementById('device_scrollarea')?.clientHeight) !== (document.getElementById('device_scrollarea')?.scrollHeight)) || isLoading) {
            return;
        }
        fetchData();
    };

    return (
        <div className='bg-white rounded-lg py-3 h-[calc(100vh-391px)] relative'>
            {items.length === 0 && isLoading ? <CustomOverLay Active text="Loading Device list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'linked_providers_overlay' : 'opened_linked_providers_overlay'}`} /> : (items.length > 0) ?
                <>
                    {/* <div className="flex justify-end mb-[14px] items-center">
                        {
                            userType !=='super-admin' &&
                            <span   
                                // onClick={() => setHelpGuideModel(true)} 
                                className='ml-auto min-w-fit cursor-not-allowed'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }

                    </div> */}

                    <div>
                        <DeviceTable
                            handleScroll={handleScroll}
                            items={items}
                            isLoading={isLoading}
                        />
                        {items.length > 0 && isLoading && <div className="flex justify-center"><BeatLoader color='#972E4C' /></div>}

                    </div>
                </> : <>
                    {items?.length === 0 && !isLoading && <div className='bg-white rounded-lg py-3 px-6 h-calc[100vh-370px] flex flex-col justify-center items-center'>
                        <img src="/images/emptyscreen_img.png" alt="emptyscreen" className="mx-auto" />
                        <p className="text-center text-xl font-normsl text-[#000]">No devices linked yet</p>
                    </div>}
                </>}
            {(helpGuideModel && helpguidestatus === "fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </div>
    )
}